import { inject, Injectable, Injector, Type } from '@angular/core';
import { AlertComponent, AlertOptions } from './alert.component';
import { ConfirmComponent, ConfirmOptions } from './confirm.component';
import { DIALOG_DATA, DialogOptions, Dialogs, NgbModal, NgbModalOptions } from './dialogs';

@Injectable({
  providedIn: 'root',
})
export class DialogsService {
  public okText = 'OK';
  public cancelText = 'キャンセル';
  public title = 'ご確認ください';
  //
  readonly defaultOptions: NgbModalOptions = {
    backdrop: 'static',
    centered: true,
    keyboard: false
  };
  //
  private ngbModal = inject(NgbModal);
  private injector = inject(Injector);
  //
  constructor(){
    Dialogs.Dialogs = this;
  }
  //
  open<Component, DATA extends DialogOptions>(compnent: Type<Component>, data: DATA, options?: NgbModalOptions) {
    const { ngbModal } = this;
    options = { ...this.defaultOptions, ...options };
    options.injector = Injector.create({
      providers: [
        { provide: DIALOG_DATA, useValue: data }
      ],
      parent: options.injector ?? this.injector
    });
    options.windowClass = options.windowClass ? `dialog ${options.windowClass}` : 'dialog';
    const modalRef = ngbModal.open(compnent, options);
    return modalRef.result.then($_ => !!$_, () => false);
  }
  //
  alert(message: AlertOptions['message'], title: AlertOptions['title'] = this.title, data: Partial<AlertOptions> = {}, modalOptions: NgbModalOptions = {}) {
    const $data: AlertOptions = {
      okText: this.okText,
      message,
      title,
      ...data
    };
    modalOptions = { windowClass: 'alert', ...modalOptions };
    return this.open(AlertComponent, $data, modalOptions);
  }
  //
  confirm(message: ConfirmOptions['message'], title: ConfirmOptions['title'] = this.title, data: Partial<ConfirmOptions> = {}, modalOptions: NgbModalOptions = {}) {
    const $data: ConfirmOptions = {
      okText: this.okText,
      cancelText: this.cancelText,
      message,
      title,
      ...data
    };
    modalOptions = { windowClass: 'confirm', ...modalOptions };
    return this.open(ConfirmComponent, $data, modalOptions);
  }

  

}
